<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-fussion" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<nav class="navbar navbar-expand-lg navbar-light bg-faded fullscreennav">
  <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <a class="navbar-brand logoanchr" href=""><img src="assets/images/navlogo.png" alt="logo" class="navlogo" /></a>
  <ul class="navbar-nav rightnav NavInMobile">
    <!-- <li class="nav-item ntfctnlist">		      	
        <a href="nav-link" routerLink="/notifications">
          <span class="ntfctntxt">Notifications</span>
          <img src="assets/images/notification.png" alt="toggle" class="ntfctnimg" >
          <img src="assets/images/notification_big.png" alt="toggle" class="bigNtfImg" >
        </a>
    </li> -->
    <li class="nav-item dropdown">		      	
      <a class="nav-link dropdown-toggle" href="" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

         <img *ngIf="profileImage; else defaultImage" src="{{fileuploadurl}}{{profileImage}}" alt="toggle" class="top_profile_image"/>
         <ng-template #defaultImage>
          <img src="assets/images/change_img.png" alt="toggle" class="top_profile_image"/>
         </ng-template>
      </a>
      <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
        <a class="dropdown-item" routerLink="/profile">Profile</a>
        <a class="dropdown-item" routerLink="/subscriptions">My Subscription</a>
        <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#logoutModal">Logout</a>
      </div>
    </li>
  </ul>
  <div class="collapse navbar-collapse mainnavdiv" id="navbarNavDropdown">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" [class]="{'active' : (current_url == '/dashboard')}" routerLink="/dashboard">Dashboard <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class]="{'active' : (current_url == '/profile')}" routerLink="/profile">Profile <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class]="{'active' : (current_url == '/company-store' || current_url == '/add-company-store')}" href="javascript:void(0)" routerLink="/company-store">Companies & Stores</a>
      </li> 
      <li class="nav-item">
        <a class="nav-link" [class]="{'active' : (current_url.indexOf('add-product-subscriptions') > -1) || (current_url == '/subscriptions') || (current_url == '/allot-license') || (current_url.indexOf('manage-subscriptions') > -1) }" routerLink="/subscriptions">Products & Subscriptions</a>
      </li>
      <li class="nav-item">
        <a routerLink="/payments" class="nav-link"  [class]="{'active' : (current_url === '/payments')}" href="">Payment & Billing</a>
      </li>
      <li class="nav-item">
        <a routerLink="/users" class="nav-link"  [class]="{'active' : (current_url === '/users')}" href="">Users</a>
      </li>
      
     </ul>
  </div>
  <ul class="navbar-nav rightnav NavInWeb">
      <!-- <li class="nav-item ntfctnlist">		      	
          <a href="nav-link" routerLink="/notifications"><span class="ntfctntxt">Notification</span><img src="assets/images/notification.png" alt="toggle" class="ntfctnimg" ></a>
      </li> -->
      <li class="nav-item dropdown">		      	
        <a class="nav-link dropdown-toggle" href="" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

           <img *ngIf="profileImage; else defaultImage" src="{{fileuploadurl}}{{profileImage}}" alt="toggle" class="top_profile_image"/>
           <ng-template #defaultImage>
            <img src="assets/images/change_img.png" alt="toggle" class="top_profile_image"/>
           </ng-template>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item" routerLink="/profile">Profile</a>
          <a class="dropdown-item" routerLink="/subscriptions">My Subscription</a>
          <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#logoutModal">Logout</a>
        </div>
      </li>
    </ul>
</nav>

<!-- Logout Modal -->
<div class="modal show" id="logoutModal" style="display: none;" aria-hidden="true">
  <div class="modal-dialog prchspopup">
    <div class="modal-content">
    
      <!-- Modal Header -->
      <div class="modal-header bluemdlhdr">
      </div>
      
      <!-- Modal body -->
      <div class="modal-body sucssbody">
        <div class="purchased_logo">
          <img src="assets/images/bloomview-icon.png">
        </div>
        <div class="common modalText">
          <h6 class="sucssheading">Are you sure you want to logout?</h6>
        </div>
        <div class="common text-center mr-top-30 logoutbttn">
          <button type="button" class="plcordrbtn wd-43" (click)="logoutClicked($event)">Logout </button>
          <button type="button" class="cancelbttn extndbtn" data-dismiss="modal">Cancel</button>
        </div>
      </div>
      
     
      
    </div>
  </div>
</div>
<!-- Logout Modal -->